import { Controller } from "react-hook-form";
import {
  Box,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Typography,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useState } from "react";
import React from "react";
import { IFormField } from "../../../models/app";
interface Props extends IFormField {
  errors: any;
  control: any;
  defaultValue?: any;
  setValue?: any;
}

interface IState {
  showPassword: boolean;
}

const INITIAL_STATE: IState = { showPassword: false };

const RHTextField: React.FC<Props> = ({
  label,
  name,
  placeholder,
  disabled,
  autoFocus,
  control,
  errors,
  required,
  defaultValue,
  onChange,
  setValue,
  errorMessage
}) => {
  const [state, setState] = useState(INITIAL_STATE);
  const { showPassword } = state;
  const handleClickShowPassword = () =>
    setState((prevState) => ({
      ...prevState,
      showPassword: !prevState.showPassword,
    }));

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  return (
    <>
      <Typography component="label" sx={{fontSize:'16px !important',color:'#0009'}} htmlFor={`${name}`}>
        {label}
      </Typography>
      <Box sx={{ position: "relative" }}>
        <Controller
          control={control}
          name={name}
          render={({ field }) => (
            <OutlinedInput
              fullWidth
              size="small"
              {...field}
              disabled={disabled}
              required={required}
              autoFocus={autoFocus}
              placeholder={placeholder}
              error={!!errors[name]}
              onChange={(e) => {
                onChange && onChange(e.target.value);
                setValue && setValue(name, e.target.value);
              }}
              type={showPassword ? "text" : "password"}
              defaultValue={defaultValue}
              sx={{
                "& .MuiOutlinedInput-notchedOutline": {
                  borderRadius: 3,
                },

              }}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                    sx={{ "&:hover": { backgroundColor: "transparent" } }}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
            />
          )}
        />

      </Box>
    </>
  );
};

export default RHTextField;
